// <<<HD fun isAtom(v)
// :test (true) -> true; (1) -> true; (null) -> true; (undefined) -> true
// :test ({}) -> false
const isAtom = (v) => {
  if (typeof v !== 'string' &&
    typeof v !== 'number' &&
    typeof v !== 'boolean' &&
    v !== null &&
    v !== undefined) {
    return false;
  }

  return true;
};
// >>>HDE

const isString = (v) => typeof v === 'string';
const isNumber = (v) => typeof v === 'number';
const isBoolean = (v) => typeof v === 'boolean';
const isNull = (v) => v === null;
const isUndefined = (v) => v === undefined;
const isFalsy = (v) => !v;
const isFunction = (v) => typeof v === 'function';
const isNullArray = (v) => !v || v.length === 0;

// <<<HD fun isObject(v)
// :test ({"a": 1}) -> true; ([1, 2, 3]) -> false; (null) -> false
const isObject = (v) => {
  return !!(v && typeof v === 'object' && !isArray(v));
};
// >>>HDE

// <<<HD fun isArray(v)
// :test ([1, 2]) -> true; ({}) -> false;
const isArray = (v) => Array.isArray(v);
// >>>HDE

const isObjectOrArray = (v) => isObject(v) || isArray(v);

// <<<HD fun isIntegerStr(v)
// :test ("1234") -> true; ("1234abc") -> false;
const isIntegerStr = (v) => !isNaN(Number(v.toString())) && !v.includes('.');
// >>>HDE

/**
 * strict get atom data
 */
const getAtom = (json, path) => {
  const v = getValue(json, path);

  if (!isAtom(v)) {
    throw new Error('value is not atom');
  }

  return v;
};

const getValue = (json, path) => {
  const keys = getKeys(path);

  let cur = json;

  for (let i = 0; i < keys.length; i++) {
    cur = getObject(cur, keys[i]);
  }

  return cur;
};

/**
 * strict set atom data
 */
const setAtom = (json, path, v) => {
  if (!isAtom(v)) {
    throw new Error('value is not atom');
  }

  const keys = getKeys(path);
  if (!keys.length) {
    throw new Error('path is empty path');
  }

  let cur = json;
  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    cur = getObject(cur, key);
  }

  setValue(cur, keys[keys.length - 1], v);
};

const getKeys = (path) => (path + '').split('.').map(v => v.trim()).filter((v) => !!v);

const setValue = (obj, key, value) => {
  if (isArray(obj)) {
    getArrayIndex(key, obj);
  } else if (!isObject(obj)) {
    throw new Error('expect object for set in object');
  }

  obj[key] = value;
};

const getArrayIndex = (key, arr) => {
  if (!isIntegerStr(key)) {
    throw new Error(`can not set array with none integer key, ${key}`);
  }

  const keyInt = parseInt(key);
  if (keyInt < 0 || keyInt >= arr.length) {
    throw new Error(`key is out of boundary to access array, key=${keyInt}, arr=${arr}`);
  }
  return keyInt;
};

const getObject = (obj, key) => {
  if (isArray(obj)) {
    const keyInt = getArrayIndex(key, obj);
    return obj[keyInt];
  }
  if (!isObject(obj)) {
    throw new Error(`expect object for get in object, obj=${obj}, key=${key}`);
  }
  return obj[key];
};

const joinJsonPath = (p1, p2) => {
  return getKeys(p1).concat(getKeys(p2)).join('.');
};

const getArray = (json, path) => {
  const arr = getValue(json, path);
  if (!isArray(arr)) {
    throw new Error(`expect array, but get json=${JSON.stringify(json)} and path=${path}`);
  }
  return arr;
};

const getLength = (json, path) => {
  const v = getArray(json, path);
  return v.length;
};

const push = (json, path, v) => {
  const arr = getArray(json, path);
  arr.push(v);
  return arr;
};

const pop = (json, path) => {
  const arr = getArray(json, path);
  return arr.pop();
};

const removeKey = (json, path) => {
  const keys = getKeys(path);
  if (!keys.length) {
    throw new Error('path is empty path');
  }

  let cur = json;
  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    cur = getObject(cur, key);
  }

  if (!isObject(cur)) {
    throw new Error('expect object to remove key');
  }

  delete cur[keys[keys.length - 1]];
};

const setKey = (json, path, value) => {
  const keys = getKeys(path);
  if (!keys.length) {
    throw new Error('path is empty path');
  }

  let cur = json;
  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    cur = getObject(cur, key);
  }

  if (!isObject(cur)) {
    throw new Error('expect object to remove key');
  }
  const lastKey = keys[keys.length - 1];
  cur[lastKey] = value;
};

const hasKey = (json, path) => {
  const keys = getKeys(path);
  if (!keys.length) {
    throw new Error('path is empty path');
  }

  let cur = json;
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (!isObject(cur) && !isArray(cur)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(cur, key)) {
      return false;
    }
    cur = cur[key];
  }

  return true;
};

/**
 * string | number | null | undefined | boolean | array | function | object
 */
// <<<HD fun getType(v)
// :test (true) -> "boolean"; (1) -> "number"; (null) -> "null"; (undefined) -> "undefined"
// :test ({}) -> "object"
// :test ([]) -> "array"
const getType = (v) => {
  const tpe = typeof v;

  if (tpe === 'string' || tpe === 'number' || tpe === 'boolean' || tpe === 'function') {
    return tpe;
  }

  if (v === null) {
    return 'null';
  }

  if (v === undefined) {
    return 'undefined';
  }

  if (Array.isArray(v)) {
    return 'array';
  }

  return 'object';
};
// >>>HDE

const flatten = (children) => {
  if (!Array.isArray(children)) {
    return [children];
  }

  const ans = [];
  flattenHelp(children, ans);
  return ans;
};

const flattenHelp = (children, ans) => {
  for (let i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      flattenHelp(children[i], ans);
    } else {
      ans.push(children[i]);
    }
  }
};

const compact = (list) => {
  return list.filter(v => v !== null && v !== undefined);
};

export {
  getValue,
  getArray,
  joinJsonPath,
  isString,
  isArray,
  isObject,
  isObjectOrArray,
  isIntegerStr,
  isFunction,

  isNumber,
  isBoolean,
  isNull,
  isUndefined,
  isFalsy,
  isNullArray,

  // atom operations
  isAtom,
  getAtom,
  setAtom,

  // array operations
  push,
  pop,
  getLength,

  // object operations
  removeKey,
  hasKey,
  setKey,

  //type operations
  getType,

  getKeys,

  flatten,
  compact,
};
